import type { StripeSyncState } from '@/design-system/billing';

/**
 * Derived Stripe sync state for a plan row.
 */
export function resolveStripeSyncState(item: {
  stripeProductId?: string | null;
  pricesCount?: number;
  syncedPricesCount?: number;
}): StripeSyncState {
  const prices = item.pricesCount ?? 0;
  const synced = item.syncedPricesCount ?? 0;
  if (prices === 0 && !item.stripeProductId) return 'NOT_SYNCED';
  if (prices === 0) return 'NO_PRICE';
  if (!item.stripeProductId || synced < prices) return 'PENDING';
  return 'SYNCED';
}
